import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  showCreateProviderConfigForm: false,
  showCancelProviderConfigForm: false,
};

const createProviderConfigSlice = createSlice({
  name: 'createProviderConfig',
  initialState,
  reducers: {
    setShowCreateProviderConfigForm: (state, { payload }) => {
      state.showCreateProviderConfigForm = payload;
    },
    setShowCancelProviderConfigForm: (state, { payload }) => {
      state.showCancelProviderConfigForm = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: createProviderConfigReducer } = createProviderConfigSlice;
export const { setShowCreateProviderConfigForm, setShowCancelProviderConfigForm } =
  createProviderConfigSlice.actions;
